import { ReactElement, useCallback } from "react";
import { h } from "../../h";
import { logInToggle } from "../../actions";
import { useDispatch, useSelector } from "react-redux";
import { getIsAuthorized } from "../../state/user.selectors";

export const LogIn = (): ReactElement => {
    const dispatch = useDispatch();
    const isAuthorized = useSelector(getIsAuthorized);
    const onClick = useCallback(() => {
        dispatch(logInToggle());
    }, [dispatch]);
    return h(
        `div`,
        {
            onClick,
        },
        isAuthorized ? `Account` : `Log in`,
    );
};
